import { render, staticRenderFns } from "./StrIsoIcTetkikCevap.vue?vue&type=template&id=a36ba7ee"
import script from "./StrIsoIcTetkikCevap.vue?vue&type=script&lang=js"
export * from "./StrIsoIcTetkikCevap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports